const ITEMS = [
  "FURNITURE",
  "APPLIANCES",
  "ESTATE CLEANOUTS",
  "CONSTRUCTION DEBRIS",
  "SHED DEMOLITION",
  "HOT TUB REMOVAL",
  "YARD DEBRIS",
  "RECYCLE & DONATE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative overflow-hidden border-y border-[#282C34] bg-[#14171C] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-6 pr-6 font-display text-3xl tracking-wider text-zinc-500 sm:text-4xl"
              >
                {item}
                <span className="hazard-thin inline-block h-3 w-3 rotate-45" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
